import { TESTIMONIALS } from '../data/content';
import './Testimonials.css';

export default function Testimonials() {
  return (
    <section className="section-divider">
      <div className="section-wrap">
        <span className="eyebrow">Customer stories</span>
        <h2 className="sec-title">Trusted by teams that can't afford downtime.</h2>
        <div className="tgrid">
          {TESTIMONIALS.map(t => (
            <div key={t.name} className="tcard">
              <div className="tcard__stars">★★★★★</div>
              <p className="tcard__quote">{t.quote}</p>
              <div className="tcard__author">
                <div className="tcard__av">{t.initials}</div>
                <div>
                  <div className="tcard__name">{t.name}</div>
                  <div className="tcard__title">{t.title}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
